import { render, staticRenderFns } from "./layTotal.vue?vue&type=template&id=5421f3a4&scoped=true"
import script from "./layTotal.vue?vue&type=script&lang=js"
export * from "./layTotal.vue?vue&type=script&lang=js"
import style0 from "./layTotal.vue?vue&type=style&index=0&id=5421f3a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5421f3a4",
  null
  
)

export default component.exports